import { put, takeEvery, call } from "redux-saga/effects";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes from "./constants";
import endpoints from "../endpoints";
import api from "../api";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}`, value: value.initPayload });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* fetchCurrentAlert() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    type: "current",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/alert`,
      method: "POST",
      sucessAction: actionTypes.FETCH_CURRENT_ALERT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_CURRENT_ALERT_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonFunction, params);

    return Res;
  } catch (e) {}
}

function* fetchAlertHistory(value) {
  let page = value.value.page;
  let aptNumber = value.value.aptNumber;
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    type: "history",
    limit: 50,
    page: page || value.value,
    aptNumber: aptNumber || "",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/alert`,
      method: "POST",
      sucessAction: actionTypes.FETCH_ALERT_HISTORY_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_ALERT_HISTORY_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonFunction, params);

    return Res;
  } catch (e) {}
}

function* alertValveAction(value) {
  const Username = JSON.parse(localStorage.getItem("FmsUser")).username;
  const token = localStorage.getItem("fmsToken");
  const data = {
    meterId: value?.value?.meterId,
    action: value.value.value,
    username: Username,
    adminFlag: true,
    userInterface: "admin",
    actionReason: "admin",
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.POST_CURRENT_ALERT_ACTION_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success(
        "Action to " + value.value.value + " valve has been sent",
        {
          autoClose: 3000,
        }
      );
      yield put({
        type: actionTypes.FETCH_CURRENT_ALERT_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.POST_CURRENT_ALERT_ACTION_FAIL_ACTION,
        error: err,
      });
      yield toast.error(
        "Action to " + value.value.value + " valve has failed",
        {
          autoClose: 3000,
        }
      );
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSupportAddApartment() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getapartmenttype`,
      method: "POST",
      sucessAction: actionTypes.FETCH_APT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_APT_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonFunction, params);

    return Res;
  } catch (e) {}
}

export function* AlertsBActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_CURRENT_ALERT_INIT_ACTION,
    fetchCurrentAlert
  );
  yield takeEvery(
    actionTypes.FETCH_ALERT_HISTORY_INIT_ACTION,
    fetchAlertHistory
  );
  yield takeEvery(
    actionTypes.POST_CURRENT_ALERT_ACTION_INIT_ACTION,
    alertValveAction
  );
  yield takeEvery(actionTypes.FETCH_APT_INIT_ACTION, fetchSupportAddApartment);
}
